import { usePublicSiteData } from "./PublicSiteContext";
import PublicServiceCard from "./PublicServiceCard";

const PublicServicesPage = () => {
  const website = usePublicSiteData();

  return (
    <>
      <section className="psite-page-hero">
        <div className="psite-page-hero__inner">
          <h1>Our Services</h1>
          <p>
            Explore the services and procedures we offer.
          </p>
        </div>
      </section>

      <section className="psite-section">
        <div className="psite-section__inner">
          <div className="psite-services">
            {(website?.services ?? []).length > 0 ? (
              website!.services.map((service) => (
                <PublicServiceCard key={service.id} service={service} />
              ))
            ) : (
              <p className="psite-section__empty">
                No services published yet.
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default PublicServicesPage;